<p-toast position="top-center" [preventOpenDuplicates]="true"> </p-toast>
<div *ngIf="user$ | async as user; else ghostProfile" class="p-4">
  <form class="flex flex-column gap-3">
    <label for="name">
      Name
      <input type="text" [value]="user.name" readonly id="name" name="name" />
    </label>
    <label for="email">
      Email Address
      <input
        type="email"
        [value]="user.email"
        readonly
        id="email"
        name="email"
      />
    </label>
  </form>
  <hr class="divider" />
  <p-button
    type="button"
    styleClass="p-button-outlined .p-button-loading-label-only"
    [disabled]="resetLoading"
    (click)="reset()"
  >
    Reset Password
  </p-button>
</div>
<ng-template #ghostProfile>
  <div class="ghost-form">
    <div class="ghost-input-group">
      <div class="ghost-label"></div>
      <div class="ghost-input"></div>
    </div>
    <div class="ghost-input-group">
      <div class="ghost-label"></div>
      <div class="ghost-label ghost-label-address"></div>
      <div class="ghost-input"></div>
    </div>
  </div>
  <hr class="divider" />
  <div class="ghost-button"></div>
  <div class="ghost-button"></div>
</ng-template>
